export default {"src":"/_next/static/media/viewers1.2dd2fdac.svg","height":919,"width":1340};